import { EventCatalogFromKeys, EventType } from "../../types";

export const AdminCommunicationsEventKeys = {
  ADMIN_COMMUNICATION_LOG_FORM_SUBMIT_ATTEMPT:
    "admin-communication-log-form-submit-attempt",
  ADMIN_COMMUNICATION_LOG_FORM_SUBMIT_FAILURE:
    "admin-communication-log-form-submit-failure",
  ADMIN_COMMUNICATION_LOG_FORM_SUBMIT_SUCCESS:
    "admin-communication-log-form-submit-success",
  ADMIN_COMMUNICATIONS_PAGE_VIEW: "admin-communications-page-view",
} as const;

export const AdminCommunicationsEventCatalog: EventCatalogFromKeys<
  typeof AdminCommunicationsEventKeys
> = {
  [AdminCommunicationsEventKeys.ADMIN_COMMUNICATIONS_PAGE_VIEW]: {
    description: "Admin viewed the communications page",
    eventType: EventType.PAGE_VIEW,
    id: AdminCommunicationsEventKeys.ADMIN_COMMUNICATIONS_PAGE_VIEW,
  },
  [AdminCommunicationsEventKeys.ADMIN_COMMUNICATION_LOG_FORM_SUBMIT_ATTEMPT]: {
    description: "Admin attempted to submit the communication log form",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminCommunicationsEventKeys.ADMIN_COMMUNICATION_LOG_FORM_SUBMIT_ATTEMPT,
  },
  [AdminCommunicationsEventKeys.ADMIN_COMMUNICATION_LOG_FORM_SUBMIT_SUCCESS]: {
    description: "Admin successfully submitted the communication log form",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminCommunicationsEventKeys.ADMIN_COMMUNICATION_LOG_FORM_SUBMIT_SUCCESS,
  },
  [AdminCommunicationsEventKeys.ADMIN_COMMUNICATION_LOG_FORM_SUBMIT_FAILURE]: {
    description: "Admin failed to submit the communication log form",
    eventType: EventType.ERROR,
    id: AdminCommunicationsEventKeys.ADMIN_COMMUNICATION_LOG_FORM_SUBMIT_FAILURE,
  },
};
